import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
});

export const getRolesApi = async (payload = {}) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/roles/list`,
      {
        page: payload.page || 1,
        limit: payload.limit || 10,
        search: payload.search || "",
      },
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to fetch roles.",
    };
  }
};

export const getRoleStatsApi = async () => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/roles/stats`,
      {},
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to fetch role statistics.",
    };
  }
};

export const getRoleApi = async (roleId) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/roles/view`,
      { role_id: roleId },
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to fetch role.",
    };
  }
};

export const createRoleApi = async (payload) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/roles/create`,
      {
        role_title: payload.role_title || "",
        role_meta_title: payload.role_meta_title || "",
        role_keyword: payload.role_keyword || "",
      },
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to create role.",
    };
  }
};

export const updateRoleApi = async (payload) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/roles/update`,
      {
        role_id: payload.role_id,
        role_title: payload.role_title || "",
        role_meta_title: payload.role_meta_title || "",
        role_keyword: payload.role_keyword || "",
      },
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to update role.",
    };
  }
};

export const deleteRoleApi = async (roleId) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/roles/delete`,
      { role_id: roleId },
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to delete role.",
    };
  }
};